import React from "react";
import {
  AppstoreOutlined,
  ContainerOutlined,
  DesktopOutlined,
  MailOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
  BarChartOutlined,
  SafetyOutlined,
  BankOutlined,
  DollarOutlined,
} from '@ant-design/icons';

export const NavigationItems = (onNavChange) => {
  // Check if aggregated stats is enabled
  const isAggregatedStatsEnabled = window.ENV_CONFIG?.ENABLE_AGGREGATED_STATS || false;

  // Build analytics children dynamically
  const analyticsChildren = [
    { key: 'analytics_dashboard', label: 'Dashboard' }
  ];

  // Only add Center Performance if aggregated stats is enabled
  if (isAggregatedStatsEnabled) {
    analyticsChildren.push({ key: 'center_analytics', label: 'Center Performance' });
  }

  // Check if session tracking is enabled
  const isSessionTrackingEnabled = window.ENV_CONFIG?.ENABLE_SESSION_TRACKING || false;

  const items = [
    {
      key: 'analytics',
      label: 'Analytics',
      icon: <BarChartOutlined />,
      children: analyticsChildren,
    },
    {
      key: 'users',
      label: 'Manage Users',
      icon: <MailOutlined />,
      children: [
        { key: 'users_list', label: 'Users' },
        { key: 'add_user', label: 'Add User' },
      ],
    },
    {
      key: 'nodes',
      label: 'Node Configuration',
      icon: <AppstoreOutlined />,
      children: [
        { key: 'nodes_list', label: 'Nodes List' },
        { key: 'add_node', label: 'Add New Node' },
      ],
    },
    {
      key: 'templates',
      label: 'Templates',
      icon: <AppstoreOutlined />,
      children: [
        { key: 'templates_list', label: 'Templates List' },
        { key: 'add_template', label: 'Add New Template' },
      ],
    },
    {
      key: 'centers',
      label: 'Centers',
      icon: <BankOutlined />,
      children: [
        { key: 'centers_list', label: 'Centers List' },
        { key: 'add_center', label: 'Add New Center' },
      ],
    },
    {
      key: 'report_config',
      label: 'Report Configuration',
      icon: <ContainerOutlined />,
      children: [
        { key: 'report_header_config', label: 'Header Template' },
      ],
    },
  ];

  // Only show Centre Billing section if enabled
  const isCentreBillingEnabled = window.ENV_CONFIG?.ENABLE_CENTRE_BILLING || false;
  if (isCentreBillingEnabled) {
    items.push({
      key: 'billing',
      label: 'Centre Billing',
      icon: <DollarOutlined />,
      children: [
        { key: 'pricing_list', label: 'Pricing Rules' },
        { key: 'add_pricing', label: 'Add Pricing Rule' },
        { key: 'cost_reports', label: 'Cost Reports' },
      ],
    });
  }

  // Only show Security section if session tracking is enabled
  if (isSessionTrackingEnabled) {
    items.splice(2, 0, {
      key: 'security',
      label: 'Security',
      icon: <SafetyOutlined />,
      children: [
        { key: 'session_management', label: 'Session Management' },
      ],
    });
  }

  return items;
}
